export function extractVersionFromHtml(html: string): string {
    const document = new DOMParser().parseFromString(html, 'text/html');
    const meta = document.head.querySelector('meta[name="application-name"]') as HTMLMetaElement | null;
    return meta?.dataset.version ?? '0.0.0';
}
